import { render, staticRenderFns } from "./TasksCrudShow.vue?vue&type=template&id=0093d630&"
import script from "./TasksCrudShow.vue?vue&type=script&lang=js&"
export * from "./TasksCrudShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports